import { Children } from 'react';
import * as S from './offerFrame.style';
import { IOfferFrame } from './offerFrame.models';

const OfferFrame: React.FC<IOfferFrame> = ({ children, variant }) => (
  <S.Container variant={variant}>
    {Children.map(children, (elem) => (
      <>
        {elem}
        <hr className="solid"/>
      </>
    ))}
  </S.Container>
);

export default OfferFrame;
